import { create } from 'zustand';

export const useConfirmStore = create<{
  isOpen: boolean;
  message: string;
  onConfirm: () => void;
  openConfirm: (message: string, onConfirm: () => void) => void;
  closeConfirm: () => void;
}>((set) => ({
  isOpen: false,
  message: '',
  onConfirm: () => {},
  openConfirm: (message, onConfirm) =>
    set({ isOpen: true, message, onConfirm }),
  closeConfirm: () => set({ isOpen: false }),
}));
